import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MapPin, Briefcase, Mail, ExternalLink, ArrowLeft } from 'lucide-react';
import ContactSellerButton from '@/components/ContactSellerButton';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TYPE_LABELS = { full_time: 'Puno radno vrijeme', part_time: 'Nepuno', contract: 'Ugovor', internship: 'Praksa', remote: 'Remote' };

export default function JobDetailPage() {
  const { id } = useParams();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/public/jobs/${id}`).then(r => r.ok ? r.json() : null).then(d => { setJob(d); setLoading(false); }).catch(() => setLoading(false));
  }, [id]);

  if (loading) return <div className="flex justify-center py-20 text-gray-400">Učitavanje...</div>;
  if (!job) return <div className="text-center py-20 text-gray-400">Oglas nije pronađen</div>;

  return (
    <>
      <Helmet><title>{`${job.title} \u2014 e-mina.eu Posao`}</title></Helmet>
      <div className="max-w-3xl mx-auto px-4 py-8" data-testid="job-detail">
        <Link to="/posao" className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700 mb-6"><ArrowLeft size={14} /> Svi oglasi</Link>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">{job.title}</h1>
        <p className="text-lg text-gray-600 mb-4">{job.company}</p>
        <div className="flex flex-wrap gap-3 text-sm text-gray-500 mb-6">
          <span className="flex items-center gap-1"><MapPin size={14} />{job.location}</span>
          <span className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full">{TYPE_LABELS[job.employment_type]}</span>
          {job.salary_range_eur && <span className="font-semibold text-emerald-600">{job.salary_range_eur} €</span>}
        </div>
        <div className="prose max-w-none mb-8" dangerouslySetInnerHTML={{ __html: job.description }} />
        <div className="flex gap-3">
          {job.application_email && <a href={`mailto:${job.application_email}`} className="flex items-center gap-2 px-5 py-2.5 bg-red-600 text-white rounded-lg font-medium text-sm hover:bg-red-700"><Mail size={16} />Prijavi se</a>}
          {job.application_url && <a href={job.application_url} target="_blank" rel="noopener" className="flex items-center gap-2 px-5 py-2.5 border border-gray-300 rounded-lg text-sm hover:bg-gray-50"><ExternalLink size={16} />Prijava online</a>}
        </div>
        <div className="mt-3 max-w-sm">
          <ContactSellerButton listingType="job" listingId={job.id} ownerName={job.company} />
        </div>
      </div>
    </>
  );
}
